import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";
import { CustomFieldDefinition, CustomFieldValues } from "../types/customFields";

class CustomFieldsService {
  private getAuthHeaders(): object {
    return {
      Authorization: getAuthUser()?.accessToken,
    };
  }

  async listDefinitions(): Promise<CustomFieldDefinition[]> {
    const response = await axios.get(`${getApiUrlWithVersion()}/custom_fields`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async createDefinition(
    name: string,
    field_type: string,
    options?: { choices?: string[] }
  ): Promise<CustomFieldDefinition> {
    const response = await axios.post(
      `${getApiUrlWithVersion()}/custom_fields`,
      { name, field_type, options: options || {} },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async updateDefinition(
    id: string,
    data: { name?: string; field_type?: string; options?: { choices?: string[] }; position?: number }
  ): Promise<CustomFieldDefinition> {
    const response = await axios.put(
      `${getApiUrlWithVersion()}/custom_fields/${id}`,
      data,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async deleteDefinition(id: string): Promise<void> {
    await axios.delete(`${getApiUrlWithVersion()}/custom_fields/${id}`, {
      headers: this.getAuthHeaders(),
    });
  }

  async updateSubscriberFields(
    subscriberId: string,
    values: CustomFieldValues
  ): Promise<any> {
    const response = await axios.patch(
      `${getApiUrlWithVersion()}/subscribers/${subscriberId}/custom_fields`,
      { custom_fields: values },
      { headers: { ...this.getAuthHeaders(), "Content-Type": "application/json" } }
    );
    return response.data;
  }

  async bulkAssign(
    fieldId: string,
    value: string | number | boolean,
    scope: "all" | "segment",
    segmentId?: string
  ): Promise<void> {
    await axios.post(
      `${getApiUrlWithVersion()}/subscribers/bulk_assign_custom_field`,
      { field_id: fieldId, value, scope, segment_id: segmentId },
      { headers: this.getAuthHeaders() }
    );
  }
}

const customFieldsService = new CustomFieldsService();
export default customFieldsService;
